import { Directive } from '@angular/core';
import { NoDataTemplateDirective } from '@progress/kendo-angular-dropdowns';

@Directive({
  selector: '[qpointSuggestlistNoDataTemplate]',
  standalone: true,
})
export class QPointSuggestlistNoDataTemplateDirective extends NoDataTemplateDirective {
}
